"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResizeObserver = void 0;
const react_1 = require("react");
const resize_observer_polyfill_1 = __importDefault(require("resize-observer-polyfill"));
exports.useResizeObserver = (ref, callback) => {
    const handleResize = react_1.useCallback((entries) => {
        const entry = entries[0];
        if (callback) {
            callback(entry.contentRect);
        }
    }, [callback]);
    react_1.useEffect(() => {
        if (!ref.current) {
            return;
        }
        let RO = new resize_observer_polyfill_1.default(handleResize);
        RO.observe(ref.current);
        return () => {
            RO && RO.disconnect();
            RO = null;
        };
    }, [handleResize, ref]);
};
//# sourceMappingURL=useResizeObserver.js.map